import dayjs from 'dayjs';
export function serializeDate(date: any): any {
    if (date instanceof Date) {
        return dayjs(date).format('YYYY-MM-DDT12:00:00');
    }
    return date;
}
